import ApiInstance from 'api/apiInstance';

export class CommonApi extends ApiInstance {
  static getUnitsPerDollar = (userId = '') => CommonApi.axiosGet(`${CommonApi.publicPath}/unitsPerDollar`, userId ? { userId } : null);

  static getGroupedPrices = (userId = '') => CommonApi.axiosGet(`${CommonApi.publicPath}/prices-in-order`, userId ? { userId } : null);
}
